import {
  Button,
  Card,
  Classes,
  FormGroup,
  InputGroup,
} from '@blueprintjs/core'
import AlgorithmSelector from './AlgorithmSelector'
import SegmentSizeSelector from './SegmentSizeSelector'
import AdvancedSettings from './AdvancedSettings'

export default function SegmentationConfigPanel({
  algorithmsSelected,
  setAlgorithmsSelected,
  segSizes,
  setSegSizes,
  selected,
  segName,
  setSegName,
  validInputs,
  loading,
  advancedSettingsOpen,
  setAdvancedSettingsOpen,
  seedInputRef,
  nmfRunsInputRef,
  snmfUseHardAssignmentRef,
  snmfBalanceToleranceRef,
}) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', gap: '15px', overflowY: 'auto', overflowX: 'hidden', padding: '5px 10px 5px 5px' }}>
      <Card style={{ flexShrink: 0, padding: 0 }} elevation={1}>
        <div className={Classes.HEADING} style={{ padding: '10px 15px', borderBottom: '1px solid #e1e8ed', marginBottom: '15px' }}>
          Configuration
        </div>
        <div style={{ padding: '0 15px 15px 15px' }}>
          <AlgorithmSelector
            algorithmsSelected={algorithmsSelected}
            setAlgorithmsSelected={setAlgorithmsSelected}
          />
          <div style={{ marginTop: '20px' }}>
            <SegmentSizeSelector
              segSizes={segSizes}
              setSegSizes={setSegSizes}
              selected={selected}
            />
          </div>
        </div>
      </Card>
      <Card style={{ flexShrink: 0, padding: '15px' }} elevation={1}>
        <AdvancedSettings
          advancedSettingsOpen={advancedSettingsOpen}
          setAdvancedSettingsOpen={setAdvancedSettingsOpen}
          seedInputRef={seedInputRef}
          nmfRunsInputRef={nmfRunsInputRef}
          snmfUseHardAssignmentRef={snmfUseHardAssignmentRef}
          snmfBalanceToleranceRef={snmfBalanceToleranceRef}
          algorithmsSelected={algorithmsSelected}
        />
      </Card>
      <Card style={{ flexShrink: 0, padding: '15px' }} elevation={1}>
        <FormGroup
          helperText={`Preview: ${segName ? segName : 'q8ef-demos'} (${
            algorithmsSelected?.[0] ? algorithmsSelected[0] : 'NMF'
          }${segSizes[0]})`}
        >
          <InputGroup
            value={segName}
            onChange={ev => setSegName(ev.target.value)}
            placeholder="Segmentation Name"
            id="seg-name"
          />
        </FormGroup>
        <Button
          icon="inherited-group"
          text="Queue Segmentation"
          type="submit"
          fill
          intent={validInputs ? 'primary' : 'danger'}
          loading={loading}
          disabled={!validInputs || loading}
          style={{ marginBottom: 0, marginTop: 13 }}
        />
      </Card>
    </div>
  )
}
